'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en = require('i2l?query=sporks!i18n-data/data/locales/en');

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Provider) {
  return Provider.register(_en2.default);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.441/js/init/register/lazy/registerNumberFormatting.js
// module id = 136
// module chunks = 171 172